import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Layout } from "../components/layout";
import { PrimeButton } from "../components/prime/button";
import { login } from "../services/auth";
import { useAuthStore } from "../stores/auth";
import { useLocale } from "../stores/locale";

export function Login() {
  const navigate = useNavigate();
  const authStore = useAuthStore();
  const t = useLocale((state) => state.locale);

  const [hasError, setHasError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const isValid = email.length > 0 && password.length > 0;

  return (
    <Layout showMenu={false} showTopMenu={false}>
      <div className="mt-10 mx-auto lg:w-8/12 xl:w-6/12">
        <h1 className="text-3xl">{t.login.title}</h1>
        <form
          onSubmit={(e) => {
            (async () => {
              setIsLoading(true);
              e.preventDefault();
              try {
                await login(email, password);
                authStore.setIsAuth(true);
                navigate("/");
              } catch (error) {
                setHasError(true);
              } finally {
                setIsLoading(false);
              }
            })();
          }}
        >
          <div className="my-2">
            <label htmlFor="email">{t.login.email}</label>
            <InputText
              className="w-full"
              disabled={isLoading}
              id="email"
              invalid={hasError}
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="mt-5">
            <label htmlFor="password">{t.login.password}</label>
            <InputText
              className="w-full"
              disabled={isLoading}
              id="password"
              invalid={hasError}
              itemType="password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          <div className="mt-5 flex justify-between">
            <div className="grow">
              {hasError && (
                <Message
                  className="w-full"
                  severity="error"
                  text="Login failed. Please try again"
                />
              )}
            </div>
            <div className="min-w-32 flex justify-end">
              <PrimeButton
                disabled={!isValid}
                label={t.login.submit}
                loading={isLoading}
                type="submit"
              />
            </div>
          </div>
        </form>
      </div>
    </Layout>
  );
}
